<template>
    <li :class="`[ c-attention-item ${stateType ? `c-attention-item--${stateType}`: ''} ] ${notified ? 'is-notified':''}`">
        <svgicon class="[ c-attention-item__icon ]" :name="stateType" width="24" height="24"></svgicon>
        <div class="[ c-attention-item__text ]">
            <slot></slot>
        </div>
        <button @click="mark()" :class="`[ c-attention__button c-button--reset c-button--tiny ] ${notified ? 'is-notified':''}`">
            <div :class="`c-attention-button__animate ${notified ? 'is-notified':''}`"></div>
            <svgicon width="1em" height="1em" :class="`c-attention-button__icon ${notified ? 'is-notified':''}`" name="check-thin"></svgicon>
            <div class="c-attention-button__text"><slot name="action-text">Gemeld</slot></div><span :class="`c-attention-button__questionmark ${!notified ? 'is-notified':''}`"> ?</span>
        </button>
    </li>
</template>

<script>
    import _debounce from 'lodash/debounce'

    export default {
        props: ['icon', 'type', 'item'],

        data() {
            return {
                notified: false,
                localItem: this.item
            }
        },
        computed: {
            stateType() {
                let output = '';
                switch(this.type) {
                    case 'ProductAdded':
                    case 'SizeActivated':
                        output = 'added'
                        break;
                    case 'DeadlineExpired':
                    case 'SizeDeactivated':
                    case 'ProductRemoved':
                        output = 'removed'
                        break;
                    default:
                        output = 'added';
                }
                return output;
            }
        },
        watch: {
            'notified'() {
                this.notify()
            }
        },
        methods: {
            mark(){
                this.notified = !this.notified;
                this.$set(this.localItem, 'IsReportedToCustomer', !this.localItem.IsReportedToCustomer);
                this.updateNotification();
            },
            notify() {
                this.$parent.$emit('marked');
            },
            updateNotification: _debounce(function () {
                this.$store.dispatch('updatePreOrderNotification', {
                    preOrderId: this.$route.params.id,
                    notificationId: this.localItem.Id,
                    body: {
                        Id: this.localItem.Id,
                        IsReportedToCustomer: this.localItem.IsReportedToCustomer
                    }
                });
            }, 500),
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-attention-item {
        display: flex;
        align-items: flex-start;
        > * {
            &:not(:last-child) {
                margin-right: em($global-spacing-unit-small);
            }
        }

        &.is-notified {
            .c-attention-item__text {
                text-decoration: line-through;
            }
            .c-attention-item__icon, .c-attention-item__text {
                opacity: .5;
            }
        }
    }

    .c-attention-item__text {
        flex: 1;
    }

    .c-attention-item--added {
        color: $color-success;
    }

    .c-attention-item--removed {
        color: $color-error;
    }

    $button-transition-speed: .15s;
    .c-attention__button {
        margin-left: em(30px);
        position: relative;
        padding: em($global-spacing-unit-tiny) em($global-spacing-unit-small);
        transition: transform $button-transition-speed;
        background-color: palette(color-neutral, light);
        box-shadow: none;

        &:hover {
            box-shadow: none;
            background-color: $color-success;
            color: white;
        }

        &:focus {
            box-shadow: none !important;
        }

        .c-attention-button__text {
            position: relative;
            pointer-events: none;
            z-index: 2;
            display: inline-block;
            transition: transform $button-transition-speed;
        }

        &.is-notified {
            box-shadow: none;
            color: white;
            background-color: $color-success;

            .c-attention-button__text {
                transform: translateX(.5em);
            }
        }

        .c-attention-button__animate {
            position: absolute;
            display: block;
            z-index: 1;
            right: 100%;
            top: 0;
            height: 100%;
            width: em(15px);
            transform-origin: 100%;
            transition: transform $button-transition-speed;
            background-color: $color-success;

            &:not(.is-notified){
                transform: scaleX(0);
            }
            &.is-notified {
                box-shadow: none;
            }
        }

        .c-attention-button__icon {
            position: absolute;
            left: em(-5px);
            z-index: 3;
            transition: transform $button-transition-speed;
            &:not(.is-notified) {
                opacity: 0;
            }
            &.is-notified {
                transform: translateX(0);
            }
        }

        .c-attention-button__questionmark {
            transition: opacity $button-transition-speed;
            &:not(.is-notified) {
                opacity: 0;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/attention/AttentionItem.vue